import MigrationMessagingBanner from 'svh-conversations-settings-lib/migration/components/MigrationMessagingBanner';
import { useConnectedFormByChannelInstanceId } from 'svh-conversations-settings-lib/migration';
import { getMigrationStatusUrl } from '../../../urls/getHelpDeskMigrationUrl';
import { jsx as _jsx } from "react/jsx-runtime";
const FormMigrationBanner = ({
  channel,
  inboxId
}) => {
  const {
    channelInstanceId
  } = channel;
  const {
    connectedForm
  } = useConnectedFormByChannelInstanceId(channelInstanceId);
  if (!connectedForm) {
    return null;
  }
  return /*#__PURE__*/_jsx(MigrationMessagingBanner, {
    channel: channel,
    viewStatusRoute: getMigrationStatusUrl(inboxId, 'forms', connectedForm.id)
  });
};
FormMigrationBanner.displayName = 'FormMigrationBanner';
export default FormMigrationBanner;